import Layout from "@/views/layout/index";

const aboutUs = [
  {
    path: "/about",
    name: "About",
    isChildren: false,
    hidden: true,
    component: Layout,
    mCode:"GYWM",
    meta: {title: '关于我们', icon: 'el-icon-s-help'},
    children: [
        {
            path: '/about',
            component: () => import('@/views/aboutUs/index'),
        }
    ]
  },
]

export default aboutUs



// WEBPACK FOOTER //
// ./src/router/aboutUs/index.js